import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { TransferArtefactOwnershipForm } from '@modules/common/components/TransferArtefactOwnershipForm';
import { useUpsertDashboard } from '@modules/dashboard/hooks';
import { DialogContent } from '@mui/material';
import { ArtefactType, Scope } from 'generated/graphql';
import { useState } from 'react';

export const ChangeDashboardOwnerDialogContent = () => {
  const { showSuccessNotification, showErrorNotification } =
    useNotificationContext();

  const { closeModal } = useMuiModalContext();

  const [selectedUserID, setSelectedUserID] = useState('');
  const [selectedScope, setSelectedScope] = useState(Scope.Public);

  const { upsertDashboard, loading: isUpdating } = useUpsertDashboard();

  const onTransferOwnership = async () => {
    try {
      await upsertDashboard({
        dashboardProps: {
          createdBy: selectedUserID,
          scope: selectedScope,
        },
      });

      showSuccessNotification({
        contentComponent: `Dashboard ownership transferred successfully!`,
        props: { isClosable: true },
      });

      closeModal();
    } catch {
      showErrorNotification({
        contentComponent: `Failed to transfer ownership.`,
        props: { isClosable: true },
      });
    }
  };

  return (
    <>
      <ModalHeader
        title="Transfer Dashboard Ownership"
        showCloseButton={false}
      />
      <DialogContent sx={{ p: 0 }}>
        <TransferArtefactOwnershipForm
          selectedUserID={selectedUserID}
          selectedScope={selectedScope}
          onSelectUserID={setSelectedUserID}
          onScopeChange={setSelectedScope}
          isUpdateInProgress={isUpdating}
          artefactType={ArtefactType.Dashboard}
          analysisUseCase={undefined}
          onCancel={() => closeModal()}
          onSubmit={onTransferOwnership}
        />
      </DialogContent>
    </>
  );
};
